import iconSetPaths from '../assets/mw-icons';

export function configureMdIconProvider($mdIconProvider) {
    'ngInject';

    Object.keys(iconSetPaths).forEach((key) => {
        $mdIconProvider.iconSet(key, iconSetPaths[key], 24);
    });

    $mdIconProvider
        .defaultIconSet(iconSetPaths['action'], 24);
}



// WEBPACK FOOTER //
// ./src/lib/providers/md-icon-provider.config.ts